module.exports = __webpack_public_path__ + "static/media/hera_docs.f3c9113e.wav";